export const AnalyticsEvents = {
  PAGE_VIEW: 'page_view',
  TARGET_GROUP_PRE_EXISTING: 'target_group_pre_existing_diabetes',
  TARGET_GROUP_GESTATIONAL: 'target_group_gestational_diabetes',
  MOBILE_PROMOTION_STORE_CLICK: 'mobile_promotion_store_click',
} as const
